import { render, staticRenderFns } from "./create_exchange_common.vue?vue&type=template&id=38c5bd3c&scoped=true"
import script from "./create_exchange_common.vue?vue&type=script&lang=js"
export * from "./create_exchange_common.vue?vue&type=script&lang=js"
import style0 from "./create_exchange_common.vue?vue&type=style&index=0&id=38c5bd3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c5bd3c",
  null
  
)

export default component.exports